import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[global-modal-content]',
    standalone: false
})
export class GlobalModalContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
